<template>
  <div :class="styles">
    {{ description }}
  </div>
</template>
<script>
export default {
  name: 'Description',
  computed: {
    styles() {
      return this.$vuetify.breakpoint.xsOnly ? 'font-size-xs' : '';
    },
  },
  props: { description: String }
};
</script>
